define.alias("shared/components/shared/color-picker/swatches", "settings/components/shared/color-picker/swatches");